export default __webpack_public_path__ + "static/media/noctilucous_jade.756139e3.png";